import {useCallback} from 'react';
import querystring from 'querystring';
import {getFullOS} from '@/utils';
import {channelClickLog} from '@/api/log';
import {isWebview} from '@/utils/channel';
import {isAndroid, isIOS} from 'react-device-detect';

/**
 * send_data 구성
 * button_group(string), button_type(string), action_type(string), location(string), link_code(string | null), lk_ht(string | null)
 */

const useChannelClickLog = () => {
  // 현재 시스템 타입 - 접근한 디바이스 타입
  const getSystemType = () => {
    if (isWebview) {
      //  앱
      return 'app';
    } else if (isIOS || isAndroid) {
      // 모웹 브라우저
      return 'webm';
    }
    // PC
    return 'web';
  };

  const sendLog = useCallback(
    async (
      codeType: string,
      sendData: Record<string, string | number | boolean | null>,
      callback?: () => void,
    ) => {
      try {
        const resultParam = {
          sztype: 'CLICK',
          code_type: codeType,
          send_data: querystring.stringify({
            ...sendData,
            location: 'station',
          }),
          sys_type: getSystemType(),
          os: getFullOS(),
        };

        await channelClickLog(resultParam);

        if (callback) {
          callback();
        }
      } catch (error) {
        console.error('로그 전송에 실패 했습니다. ==> ', error);
      }
    },
    [],
  );

  return {
    sendClickLog: sendLog,
  };
};

export default useChannelClickLog;
